import { Fragment } from 'react';

import { VTAnomalyData } from '../../../../utils/models';
import { getVTTableColumns } from '../../../../utils/data';

import AutTable from '../../../blocks/aut-grid-table';
import VTPipingAnomalyItem from '../../../forms/vt/vtPipingAnomalyItem';

interface VTPipingSummaryProps {
	anomalyData: VTAnomalyData[];
	onDataChange: (items: VTAnomalyData[]) => void;
}

const VTPipingSummary = (props: VTPipingSummaryProps) => {
	const onAddItem = (item: VTAnomalyData) => {
		const newAnomalyData = [...props.anomalyData];
		newAnomalyData.push({ ...item, id: props.anomalyData.length + 1 });

		props.onDataChange(newAnomalyData);
	};

	const onDeleteItem = (item: VTAnomalyData): void => {
		const newAnomalyData: VTAnomalyData[] = props.anomalyData.filter(
			(i) => i.id !== item.id
		);
		props.onDataChange(newAnomalyData);
	};

	return (
		<Fragment>
			<VTPipingAnomalyItem onAdd={onAddItem} />

			<div className="divider my-4"></div>

			<AutTable
				data={props.anomalyData}
				tableColumns={getVTTableColumns()}
				onDeleteItem={onDeleteItem}
			/>
		</Fragment>
	);
};

export default VTPipingSummary;
